import { render, staticRenderFns } from "./FormNovoValorProduto.vue?vue&type=template&id=7569d6a7"
import script from "./FormNovoValorProduto.vue?vue&type=script&lang=js"
export * from "./FormNovoValorProduto.vue?vue&type=script&lang=js"
import style0 from "./FormNovoValorProduto.vue?vue&type=style&index=0&id=7569d6a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports